import axios from 'axios';
import * as actionTypes from '../constants/actions';
import { push } from 'redux-router';

import baseUrl from '../utils/baseUrl';
let url = baseUrl + '/api/editorials/';

function action(type) {
	return { type: type };
};

function respond(json, type) {
	//console.log(type);
	return {
		type: type,
		payload: json,
	};
};

export function clearSingleEditorial() {
	return function(dispatch) {
		dispatch(action(actionTypes.EDITORIALS_CLEAR_SINGLE));
	};
}

export function fetchEditorials(offset = 0, limit = 20, slug = false) {
	let queryParams = {
		offset: offset,
		limit: limit,
	};

	return function(dispatch) {
		dispatch(action(actionTypes.EDITORIALS_REQ_DATA));
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_DATA));
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_ERROR));

			console.log('editorials - fetch error');
			console.log(response.data);

			//dispatch(pushState(null, '/error'));
		});
	};
};

export function fetchEditorialsFromType(type = '', offset = 0, limit = 36, month = '', year = '',  q = '') {
	let queryParams = {
		type: type,
		offset: offset,
		limit: limit,
		month: month,
		year: year,
		q: q,
	};

	return function(dispatch) {
		return axios({
			url: url,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: queryParams,
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_TYPE_DATA));
		})
		.catch(function(response) {

			console.log('editorials TYPE - fetch error');
			console.log(response);

			//dispatch(pushState(null, '/error'));
		});
	};
};

export function fetchSingleEditorial(slug, success = () => {}, fail = () => {}, preview = false) {
	if (!(typeof slug === 'number' || (typeof slug === 'string' && slug.length))) {
		console.log('editorial - invalid slug');
		return function(dispatch) {
			//dispatch(pushState(null, '/error'));
		};
	}

	//console.log('fetch single editorial - ' + url + slug);

	return function(dispatch) {
		dispatch(action(actionTypes.EDITORIALS_REQ_SINGLE_DATA));

		let data= {};

		if (preview) {
			data.preview = preview;
		}

		return axios({
			url: url + slug,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: data,
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_SINGLE_DATA));
			success();
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.EDITORIALS_RECV_ERROR));
			fail();

			console.log('editorial - fetch error');
			console.log(response);

			fail();
		});
	};
}

export function editEditorial(type = false, id = false) {
	if (!type && !type.length) {
		return function(dispatch) {
			//dispatch(pushState(null, '/error'));
		};
	}

	let editUrl = baseUrl + `/api/account/editorials/${type}/form`;

	return function(dispatch) {
		//dispatch(action(actionTypes.EDITORIALS_REQ_SINGLE_DATA));
		return axios({
			url: editUrl,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
			params: {
				editorialId: id,
			},
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.ACCOUNT_EDITORIAL_RECV_DATA));
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.RECV_ERROR));

			console.log('editorials - create error');
			console.log(response.data);

			//dispatch(pushState(null, '/error'));
		});
	};
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/editorials.js
 **/